import PropTypes from 'prop-types';
import React from 'react';
import UserDetailsRow from 'components/users/UserDetailsRow';
import UserDetailsElement from 'components/users/UserDetailsElement';

const InstallerScore = (props) => {
  const { installer } = props;
  const installerScore = score => (score ? `${score}%` : 'N/A');
  return (
    <UserDetailsRow title="All Time Average Score">
      <UserDetailsElement
        title="professionalism"
        value={installerScore(installer.professionalism)}
      />
      <UserDetailsElement
        title="craftsmanship"
        value={installerScore(installer.craftsmanship)}
      />
    </UserDetailsRow>
  );
};

InstallerScore.propTypes = {
  installer: PropTypes.object,
};

export default InstallerScore;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/components/installerScore.jsx